import React, { useEffect } from 'react';
import usePushNotifications from 'hooks/usePushNotifications';

//Translations
import { useTranslate } from 'react-translate';

import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';

export default function PushNotificationAsk() {

  //Translations
  const t = useTranslate('users');

  const user = useSelector((state) => state.userReducer);
  const {
    pushNotificationSupported,
    userSubscription,
    error,
    userConsent,
    loading,
  } = usePushNotifications();

  const handleSubscribe = () => {
    /*
    setAlert(
      
      <SweetAlert
        warning
        title="Subscribe to push notifications?"
        onConfirm={() => {
          askUserPermission();
          setAlert(null);
        }}
        confirmBtnBsStyle="info"
        confirmBtnText="Subscribe"
      >
        Push notifications subscribe
      </SweetAlert>
    );
    */
   
    toast.info( t("suscribe-push-message") );
  };
  useEffect(() => {
    if (error) {
      console.log(error);
    }
  }, [error]);

  useEffect(() => {
    if (
      !loading &&
      user.status === 'success' &&
      !user.password_expired &&
      !userSubscription &&
      pushNotificationSupported &&
      userConsent === 'default'
    ) {
      handleSubscribe();
    }
    //eslint-disable-next-line
  }, [user.status, user.password_expired, userSubscription, loading]);

  return <></>;
}
